// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPropertyChangeDto } from './IPropertyChangeDto';
import {
    IPropertyChangeDtoFromJSON,
    IPropertyChangeDtoFromJSONTyped,
    IPropertyChangeDtoToJSON,
    IPropertyChangeDtoToJSONTyped,
} from './IPropertyChangeDto';

/**
 * 
 * @export
 * @interface IPropagateOverridablePropertiesRequest
 */
export interface IPropagateOverridablePropertiesRequest {
    /**
     * 
     * @type {Array<IPropertyChangeDto>}
     * @memberof IPropagateOverridablePropertiesRequest
     */
    properties: Array<IPropertyChangeDto>;
}

/**
 * Check if a given object implements the IPropagateOverridablePropertiesRequest interface.
 */
export function instanceOfIPropagateOverridablePropertiesRequest(value: object): value is IPropagateOverridablePropertiesRequest {
    if (!('properties' in value) || value['properties'] === undefined) return false;
    return true;
}

export function IPropagateOverridablePropertiesRequestFromJSON(json: any): IPropagateOverridablePropertiesRequest {
    return IPropagateOverridablePropertiesRequestFromJSONTyped(json, false);
}

export function IPropagateOverridablePropertiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPropagateOverridablePropertiesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'properties': ((json['properties'] as Array<any>).map(IPropertyChangeDtoFromJSON)),
    };
}

export function IPropagateOverridablePropertiesRequestToJSON(json: any): IPropagateOverridablePropertiesRequest {
    return IPropagateOverridablePropertiesRequestToJSONTyped(json, false);
}

export function IPropagateOverridablePropertiesRequestToJSONTyped(value?: IPropagateOverridablePropertiesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properties': ((value['properties'] as Array<any>).map(IPropertyChangeDtoToJSON)),
    };
}

